import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function FinalCTA() {
  return <section className="py-24 bg-gradient-to-b from-maroon to-[#2A0F24] text-cream text-center relative overflow-hidden" data-id="element-37">
      {/* Mercury glow effects */}
      <div className="absolute top-[-20%] left-[20%] w-[40%] h-[40%] bg-blush/5 blur-[120px] rounded-full pointer-events-none" data-id="element-38"></div>
      <div className="absolute bottom-[-20%] right-[10%] w-[30%] h-[30%] bg-silver/5 blur-[100px] rounded-full pointer-events-none" data-id="element-39"></div>

      <div className="max-w-3xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-40">
        <FadeIn data-id="element-41">
          <div className="inline-flex items-center justify-center px-4 py-2 rounded-full bg-blush/10 text-blush border border-blush/20 mb-8" data-id="element-42">
            <span className="mr-2" data-id="element-43">🔥</span>
            <span className="font-medium tracking-wide uppercase text-sm" data-id="element-44">
              Limited Spots Available
            </span>
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white mb-6" data-id="element-45">
            Start Building.
            <br data-id="element-46" />
            Start Getting Funded.
            <br data-id="element-47" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blush via-silver-light to-blush" data-id="element-48">
              Start for $0.99.
            </span>
          </h2>

          <p className="text-xl text-blush-light/80 mb-10" data-id="element-49">
            Start for $0.99 for your first 30 days. Then $24/month after. Cancel
            anytime.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-50">
            <a href="https://buy.stripe.com/bJe14m74m5KjgWygiMf3a07" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-to-r from-blush to-blush-light hover:from-blush-light hover:to-white text-maroon font-bold text-xl py-5 px-14 rounded-md transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-51">
              Join FundHER Academy for $0.99
            </a>
            <p className="text-xs text-blush-light/50" data-id="element-52">
              Cancel anytime. No contracts. No pressure.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}